import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, computed } from 'vue';
import {
  Modal,
  InputText,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Heading
} from '@warrenbrasil/nebraska-web';
import { rename } from '@/modules/wealth/services/portfolio';


export default /*#__PURE__*/_defineComponent({
  __name: 'RenamePortfolioModal',
  props: {
  isOpen: { type: Boolean, default: false },
  portfolioId: { type: String, required: true },
  portfolioName: { type: String, required: true }
},
  emits: ['close', 'reload'],
  setup(__props, { emit }) {

const props = __props;





async function savePortfolioName() {
  try {
    await rename(props.portfolioId, portfolioRenamed.value);
    emit('close');
    emit('reload');
  } catch (error) {
    console.error(error);
  }
}

const portfolioRenamed = ref('');

const counter = computed(() => {
  return `${portfolioRenamed.value.length}/30`;
});

onMounted(() => {
  portfolioRenamed.value = props.portfolioName;
});

watch(
  () => props.portfolioName,
  () => {
    portfolioRenamed.value = props.portfolioName;
  }
);

return { __sfc: true,props, emit, savePortfolioName, portfolioRenamed, counter, Modal, InputText, BaseText, ButtonContainer, ButtonPrimary, Heading }
}

})